<template>
  <div>
    <!-- first name / last name-->
    <NameSection ref='nameSection' :configuration="nameObject" :triggerNameSectionValidation="triggerWatch"/>
    <div v-if="this.$store.state.requirements['address']">
        <Address id="patient"
                :key="addressKey"
                @updateAddress="updateAddress"
                 @updateAddress2="updateAddress2"
                 :same_address2="model.address2"
                :checkRequired="checkRequirement('address')"
                :componentsInsurance="model.addressComponents"
                wizardStep="medical"
                 ref="AddressComponent"
                />
        <small class="text-danger" v-if="address_error">
          {{address_error && computeCaption(address_error, this.$store.state.lang.value.toLowerCase())}}
        </small>
    </div>
    <div>
        <GeneticsSection :type="type" :configuration="geneticsObject" ref="GeneticsSection" :triggerGeneticsWatch="triggerWatch"/>
    </div>
     <div>
      <PersonIdentifierSection :type="type" :configuration="personIdentifierObject" ref="personIdentifierSection" :triggerPersonIdentifierWatch="triggerWatch"/>
    </div>
    <div class="row">
    <div v-if="(type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate') && (checkSiteCodeInsurance() || $store.state.configs.DISPLAY_DL_SSN_PERSONAL_DATA || !$store.state.configs.HIDE_SELF_COMPLETED_FIELDS && checkSiteCodeInsurance())" class="general-inactive-section col-md-12">
    <div v-if="checkSiteCodeInsurance()">
    <div v-if="type === 'dependentRegistration' || type === 'dependentUpdate'" class="row">
      <div class="col-md-10 col-md-offset-1">
         <el-checkbox v-model="checked">{{computeCaption(fields_en['same_insurance_as_main_user'], this.$store.state.lang.value.toLowerCase())}}</el-checkbox>
      </div>
    </div>

    <!--Primary Insurance and relationship -->
      <div class="row" v-if="type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate'">
        <!-- Relationship -->
      <!--Relationship to Patient:-->
        <div class="col-md-5 col-md-offset-1 form-group">
          <label class="control-label">
            {{computeCaption(fields_en['patient_relationship_to_insured'], this.$store.state.lang.value.toLowerCase())}} </label
          ><br />
          <el-select
            size="large"
            data-vv-as="Relationship"
            v-validate="modelValidations.relationship"
            placeholder="Single Select"
            name="relationship"
            v-model="model.relationship"
          >
            <el-option
              v-for="option in relationshipList"
              class="select-danger"
              :value="option.value"
              :label="computeCaption(option.value, $store.state.lang.value.toLowerCase())"
              :key="option.label"
            >
            </el-option>
          </el-select>
          <small class="text-danger" v-show="relationship.invalid">
            {{getError("relationship") && computeCaption(getError("relationship"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </div>
        <div class="col-md-5 ">
          <div class="form-group">
            <label class="control-label">
              {{computeCaption(fields_en['primary_insurance_name'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <el-select filterable
                       type="text"
                       size="large"
                       popper-class="select-small-options"
                       data-vv-as="Primary Insurance Name"
                       v-validate="modelValidations.primary_insurance"
                       name="primary_insurance"
                       placeholder="ex: Aetna"
                       :disabled="checked === true && this.type != 'personalData'"
                       v-model="model.primary_insurance">
              <el-option v-for="option in this.$store.state.insurance"
                         class="select-danger"
                         :value="option.name"
                         :label="'* ' + option.name"
                         :key="option.name">
              </el-option>
            </el-select>
            <div class="default-grey font-small" v-show="getFieldDescription('insurance_name')" v-html="getFieldDescription('insurance_name') || ''"></div>
            <small class="text-danger" v-show="primary_insurance.invalid">
              {{getError("primary_insurance") && computeCaption(getError("primary_insurance"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>

    <!--Group Number -->
    <div class="row" v-if="type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate'">
        <!-- Insurance Name Input -->
         <div class="col-md-10 col-md-offset-1" v-if="this.model.primary_insurance === 'Other'">
          <div class="form-group">
            <label class="control-label" :class="type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate' ? '' : 'required'">
              {{computeCaption(fields_en['primary_insurance_name_input'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"  :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && checked === true)"
                  type="text"
                  data-vv-as="Primary Insurance Name"
                  name="primary_insurance_name_input"
                  v-validate="modelValidations.primary_insurance_name_input"
                  v-model="model.primary_insurance_name_input"
                  placeholder='ex: Hospital'
            />
            <small class="text-danger" v-show="primary_insurance_name_input.invalid">
              {{getError("primary_insurance_name_input") && computeCaption( getError("primary_insurance_name_input"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
         <!--policy number-->
        <div class="col-md-5 col-md-offset-1">
          <div class="form-group">
            <label class="control-label" :class="type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate' ? '' : 'required'">
              {{computeCaption(fields_en['policy_number'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"  :disabled="(this.model.insurance_pay === 'uninsured' || this.model.insurance_pay === 'cash') || (this.model.insurance_pay === 'insurance' && checked === true)"
                  type="text"
                  data-vv-as="Policy Number"
                  name="policy_number"
                  v-validate="modelValidations.policy_number"
                  v-model="model.policy_number"
                  placeholder='ex: 123456789'
            />
            <div class="default-grey font-small" v-show="getFieldDescription('policy_number')" v-html="getFieldDescription('policy_number') || ''"></div>
            <small class="text-danger" v-show="policy_number.invalid">
              {{getError("policy_number") && computeCaption(getError("policy_number"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      <!--Group Number -->
        <div class="col-md-5">
          <div class="form-group">
            <label class="control-label">
              {{computeCaption(fields_en['group_number'], this.$store.state.lang.value.toLowerCase())}}
            </label>
            <input class="form-control"
                  type="text"
                  data-vv-as="Group Number"
                  name="group_number"
                  v-validate="modelValidations.group_number"
                  v-model="model.group_number"
                  placeholder="ex: 123456789"
                  :disabled="checked === true && this.type !== 'personalData'"
            />
            <div class="default-grey font-small" v-show="getFieldDescription('group_number')" v-html="getFieldDescription('group_number') || ''"></div>
            <small class="text-danger" v-show="group_number.invalid">
              {{getError("group_number") && computeCaption(getError("group_number"), this.$store.state.lang.value.toLowerCase())}}
            </small>
          </div>
        </div>
      </div>

    <!-- Insurance personal Data information -->
    <div class="row" v-if="type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate'" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)">
    <div class="col-md-10 col-md-offset-1">
      <el-row :gutter="15">
        <!-- Insured first name -->
        <el-col :span="checkMediaScreenWidth() ? 24 : 8">
          <label>
            {{computeCaption(fields_en['insured_first_name'], this.$store.state.lang.value.toLowerCase())}}
            </label><br>
          <el-input id="firstName"
                    size="small"
                    name="insured_first_name"
                    data-vv-as="Insured First Name"
                    v-validate="modelValidations.insured_first_name"
                    v-model="model.insured_first_name"
                    :disabled="$store.state.requirements.first_name && ((model.relationship==='Self') || ((type === 'dependentUpdate' || type === 'dependentRegistration') && checked) )">
          </el-input>
           <div class="default-grey font-small" v-show="getFieldDescription('insured_first_name')" v-html="getFieldDescription('insured_first_name') || ''"></div>
          <small class="text-danger" v-show="insured_first_name.invalid">
            {{computeCaption(getError("insured_first_name"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>
        <!-- Insured middle name -->
        <el-col :span="checkMediaScreenWidth() ? 24 : 8">
          <label>
           {{computeCaption(fields_en['insured_middle_name'], this.$store.state.lang.value.toLowerCase())}}
          </label><br>
          <el-input id="middleName"
                    size="small"
                    data-vv-as="Insured Middle Name"
                    name="insured_middle_name"
                    v-validate="modelValidations.insured_middle_name"
                    v-model="model.insured_middle_name"
                    :disabled="!!$store.state.requirements.middle_name && ((model.relationship==='Self') || ((type === 'dependentUpdate' || type === 'dependentRegistration') && checked) )">
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_middle_name')" v-html="getFieldDescription('insured_middle_name') || ''"></div>
          <small class="text-danger" v-show="insured_middle_name.invalid">
            {{computeCaption(getError("insured_middle_name"), $store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>
        <!-- Insured last name -->
        <el-col :span="checkMediaScreenWidth() ? 24 : 8">
          <label>
            {{computeCaption(fields_en['insured_last_name'], this.$store.state.lang.value.toLowerCase())}}</label><br>
          <el-input id="lastName"
                    size="small"
                    name="insured_last_name"
                    data-vv-as="Insured Last Name"
                    v-validate="modelValidations.insured_last_name"
                    v-model="model.insured_last_name"
                    :disabled="$store.state.requirements.last_name && ((model.relationship==='Self') || ((type === 'dependentUpdate' || type === 'dependentRegistration') && checked) )">
          </el-input>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_last_name')" v-html="getFieldDescription('insured_last_name') || ''"></div>
          <small class="text-danger" v-show="insured_last_name.invalid">
            {{getError("insured_last_name") && computeCaption(getError("insured_last_name"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </el-col>
      </el-row>
    </div>
  </div><br>
      <!-- Dob and Gender -->
    <div v-if="type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate'" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)" class="row">
      <!--insured date of birth-->
      <div class="col-md-6 col-md-offset-1">
        <div class="form-group">
          <DobSection :required="false" label="Insured Date Of Birth" :field="'insured_date_of_birth'" ref="dobSection" :dateValue="insured_dob"
                      @updateDob="updateDob" :restrictDate="true" :disabled="$store.state.requirements.date_of_birth !== '' && ((model.relationship==='Self') || ((type === 'dependentUpdate' || type === 'dependentRegistration') && checked) )"/>
        </div>
      </div>

      <!-- insured gender -->
      <div class="col-md-4">
        <div class="form-group">
          <label class="control-label">
            {{computeCaption(fields_en['insured_gender'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <el-select size="large"
                     data-vv-as="Insured Gender"
                     v-validate="modelValidations.insured_gender"
                     placeholder="Single Select"
                     name="insured_gender"
                     v-model="model.insured_gender"
                    :disabled="$store.state.requirements.gender !== '' && ((model.relationship==='Self') || ((type === 'dependentUpdate' || type === 'dependentRegistration') && checked) )"
                     >
              <el-option v-for="option in $store.state.gender"
                         class="select-danger"
                         :value="option.name"
                         :label="computeCaption(option.name, $store.state.lang.value.toLowerCase())"
                         :key="option.name">
              </el-option>
          </el-select>
          <div class="default-grey font-small" v-show="getFieldDescription('insured_gender')" v-html="getFieldDescription('insured_gender') || ''"></div>
          <small class="text-danger" v-show="insured_gender.invalid">
            {{getError("insured_gender") && computeCaption(getError("insured_gender"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
    </div>
      <!-- Address -->
    <div v-if="type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate'" v-show="!(this.model.relationship === 'Self' && this.hide_self_completed_fields)" class="row">
      <div class="col-md-10 col-md-offset-1">
        <Address id="insurance"
                 :isDisabled="($store.state.requirements.address && ((model.relationship==='Self') || ((type === 'dependentUpdate' || type === 'dependentRegistration') && checked) ))"
                 :key= "insuredAddress"
                @updateAddress="insuredUpdateAddress"
                 @updateAddress2="insuredUpdateAddress2"
                 :same_address2="model.insured_address2"
                :componentsInsurance="model.insured_address_components"
                :checkRequired="false"
                wizardStep="insurance" />
        <small class="text-danger" v-if="insured_address_error">
          {{insured_address_error && computeCaption(insured_address_error, this.$store.state.lang.value.toLowerCase())}}
        </small>
      </div>
    </div>
    </div>
    <!-- Driver license number or SSN -->
    <div class="row" v-if="(type === 'personalData' || type === 'dependentRegistration' || type === 'dependentUpdate') && $store.state.configs.DISPLAY_DL_SSN_PERSONAL_DATA !== false">
      <!-- Driver license number  -->
      <div class="col-md-4 col-md-offset-1">
        <div class="form-group">
          <label class="control-label">
            {{computeCaption(fields_en['driver_license_number'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <input class="form-control"
                 type="text"
                 data-vv-as="Driver License Number"
                 name="driver_license_number"
                 v-validate="modelValidations.driver_license_number"
                 v-model="model.driver_license_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('driver_license_number')" v-html="getFieldDescription('driver_license_number') || ''"></div>
        </div>
      </div>

      <div class="col-md-1 mb-10">
        <small class="border-none">OR</small>
      </div>

      <div class="col-md-5">
        <div class="form-group">
          <label class="control-label">
            {{computeCaption(fields_en['social_security_number'], this.$store.state.lang.value.toLowerCase())}}
          </label>
          <input class="form-control ssn-cleave-format"
                 autocomplete="off"
                 type="text"
                 data-vv-as="Social Security Number"
                 name="social_security_number"
                 v-validate="modelValidations.social_security_number"
                 v-on:keyup.backspace="cleaveBackspaceFix($event.target)"
                 v-model="model.social_security_number"
          />
          <div class="default-grey font-small" v-show="getFieldDescription('social_number')" v-html="getFieldDescription('social_number') || ''"></div>
          <small class="text-danger" v-show="social_security_number.invalid">
            {{getError("social_security_number") && computeCaption(getError("social_security_number"), this.$store.state.lang.value.toLowerCase())}}
          </small>
        </div>
      </div>
      </div>
    </div>
    </div>
       <!--DRIVER LICENSE -->
    <div class="text-center" v-if="allow_driver_license && type === 'Registration'">
      <br/>
      <h5 >
        <span v-html="computeCaption(fields_en['upload_driver_license'], $store.state.lang.value.toLowerCase())"></span>
        <br/>
        <small>{{ computeCaption(fields_en['minors_quote'], $store.state.lang.value.toLowerCase()) }}</small>
      </h5>
    </div>
    <div class="row" v-if="allow_driver_license && type === 'Registration'">
      <MultipleInput :caption="computeReportableCaption('driver_license_image', fields_en['driver_license'], $store.state.lang.value.toLowerCase())" :partOfSection="false" :allow="allow_driver_license" :required="required_driver_license" ref="driverLicense"></MultipleInput>
    </div>

    <!-- Kit Number Scanner -->
    <ScanningModule v-if="this.$store.state.requirements.kit_number && type === 'Registration'" :text_ph="fields_en.scan_kit_text" :required="required_kit_number" ref="scanningModule"></ScanningModule>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {Row, Col, Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker, Checkbox} from 'element-ui'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import axios from 'axios'
  import Cleave from 'cleave.js'
  import Address from '../../Utils/Sections/Address.vue'
  import NameSection from '../../Utils/Sections/NameSection.vue'
  import GeneticsSection from '../../Utils/Sections/GeneticsSection.vue'
  import PersonIdentifierSection from '../../Utils/Sections/PersonIdentifierSection.vue'
  import MultipleInput from '../../Utils/Sections/MultipleInput.vue'
  import ScanningModule from '../../Utils/SubComponents/MultipleUseParts/ScanningModule'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
  import {AccessionUtils} from '../../../../../utils/AccessionDetailsProcessing'
  import {LayoutCalculationUtils} from '../../../../../utils/LayoutCalculation'
  import _ from 'lodash'
  import DobSection from '../../Utils/SubComponents/MultipleUseParts/Date'
  import {PatientInfoUtils} from '../../../../../utils/PatientInfo'
  require('cleave.js/dist/addons/cleave-phone.us')
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT PHONE NUMBER
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
  export default {
    components: {
      DobSection,
      [Input.name]: Input,
      [DatePicker.name]: DatePicker,
      [Autocomplete.name]: Autocomplete,
      [Drawer.name]: Drawer,
      [Button.name]: Button,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [RadioButton.name]: RadioButton,
      [Checkbox.name]: Checkbox,
      Address,
      NameSection,
      GeneticsSection,
      PersonIdentifierSection,
      MultipleInput,
      ScanningModule,
      [Row.name]: Row,
      [Col.name]: Col
    },
    mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils, AccessionUtils, LayoutCalculationUtils, PatientInfoUtils],
    props: ['type', 'triggerWatch'],
    data () {
      return {
        nameObject: {},
        personIdentifierObject: {},
        geneticsObject: {},
        generalClass: 'general-inactive-section',
        validatedSectionClass: '',
        open: false,
        allow_driver_license: this.$store.state.configs.ALLOW_DRIVER_LICENSE,
        addressInitial: {
          name: '',
          original_name: '',
          delivery_line_1: '',
          city_name: '',
          county: '',
          state_abbreviation: '',
          zipcode: '',
          plus4_code: '',
          county_fips: '',
          country: ''
        },
        addressKey: 99999,
        insured_address_error: '',
        insuredAddress: 1,
        dateRequired: true,
        searchedAddress: '',
        address_error: '',
        questionError: '',
        checked: '',
        phoneTransaction: false,
        drawer: false,
        dateScanned: false,
        double_entry_email: this.$store.state.configs.DOUBLE_ENTRY_EMAIL,
        force_valid_address: this.isTrue(this.$store.state.configs.FORCE_VALID_ADDRESS),
        allow_user_demo: this.$store.state.configs.ALLOW_USER_DEMO,
        suggestions: [],
        smartystreets_key: this.$store.state.configs.SMARTYSTREETS_KEY,
        answers_es: {},
        answers_zh: {},
        requirements: [],
        errorDate: '',
        errorInsuredDate: '',
        questionErrorDate: [],
        insured_dob: '',
        answer_no: 'No',
        allow_above_medication_text: this.$store.state.configs.ALLOW_ABOVE_MEDICATION_TEXT,
        required_kit_number: false,
        fields_en: {
          same_insurance_as_main_user: 'Same insurance as main user',
          med_social_security_number: 'Social Security Number',
          driver_license: 'Driver License',
          passport: 'Passport',
          first_name: 'First Name',
          address: 'Address',
          address2: 'Address 2',
          last_name: 'Last Name',
          email: 'Email',
          phone: 'Phone',
          please_answer_to_the_best_of_your_knowledge: 'Please answer to the best of your knowledge',
          above_please_tell_us_more_about_yourself: 'The new Federal Mandate for Covid Testing requires ALL patient info to be accurate. Incorrect patient info may delay results or result in the sample being rejected.',
          please_tell_us_more_about_yourself: 'Please tell us more about yourself',
          answer_required: 'Answer required',
          patient_relationship_to_insured: 'Relationship to Insured',
          primary_insurance_name: 'Primary Insurance Name',
          primary_insurance_name_input: 'Insurance Name',
          policy_number: 'Policy Number',
          group_number: 'Group Number',
          insured_first_name: 'Insured First Name',
          insured_middle_name: 'Insured Middle Name',
          insured_last_name: 'Insured Last Name',
          insured_date_of_birth: 'Insured Date of Birth',
          insured_gender: 'Insured Gender',
          driver_license_number: 'Driver license number',
          social_security_number: 'Social Security Number',
          scan_kit_text: 'Use scan button or type Kit number',
          upload_driver_license: 'Now upload or take a picture <b>of the front of your driver license or ID</b>',
          minors_quote: 'For minors please use the guardian driver license or ID'
        },
        relationshipList: [{value: 'Self', label: 'Self'}, {value: 'Child', label: 'Child'}, {value: 'Parent', label: 'Parent'}, {value: 'Spouse', label: 'Spouse'}],
        relationshipListWithoutSelf: [{value: 'Child', label: 'Child'}, {value: 'Parent', label: 'Parent'}, {value: 'Spouse', label: 'Spouse'}],
        relationshipListWithSelf: [{value: 'Self', label: 'Self'}],
        model: {
          med_driver_license_number: this.$store.state.userData['driver_license_number'] || '',
          relationship: '',
          driver_license_images: [],
          driver_license_names: [],
          address: this.$store.state.userData['address'] || '',
          address2: this.$store.state.userData['address2'] || '',
          addressComponents: this.$store.state.userData['addressComponents'] || this.addressInitial,
          primary_insurance: this.$store.state.userData['primary_insurance'] || '',
          primary_insurance_name_input: '',
          policy_number: this.$store.state.userData['policy_number'] || '',
          group_number: this.$store.state.userData['group_number'] || '',
          driver_license_number: this.$store.state.userData['driver_license_number'] || '',
          social_security_number: this.$store.state.userData['social_number'] || '',
          insured_first_name: this.$store.state.userData['insured_first_name'] || '',
          insured_middle_name: this.$store.state.userData['insured_middle_name'] || '',
          insured_gender: this.$store.state.userData['insured_gender'] || '',
          insured_last_name: this.$store.state.userData['insured_last_name'] || '',
          insured_date_of_birth: this.$store.state.userData['insured_date_of_birth'] || '',
          insured_address_components: this.$store.state.userData['insured_address_components'] || this.addressInitial,
          insured_address: this.$store.state.userData['insured_address'] || '',
          insured_address2: this.$store.state.userData['insured_address2'] || ''
        },
        modelValidations: {
          relationship: {
            required: false
          },
          driver_license_image: {
            required: this.$store.state.configs['ALLOW_DRIVER_LICENSE'] === true && this.required_driver_license === true
          },
          primary_insurance: {
          },
          primary_insurance_name_input: {
            required: true
          },
          policy_number: {
            min: 2
          },
          group_number: {
          },
          driver_license_number: {
          },
          social_security_number: {
            min: 11,
            max: 11
          },
          insured_first_name: {
          },
          insured_middle_name: {

          },
          insured_last_name: {
          },
          insured_gender: {
          },
          insured_address: {
            min: 5
          },
          insured_address2: {},
          med_driver_license_number: {
          },
          med_social_security_number: {
            required: this.checkRequirement('social-number'),
            min: 11,
            max: 11
          }
        },
        address_smartystreets_selected: {
          invalid: false,
          error_message: 'Looks like we don\'t know this address, please make sure the address is correct',
          first_result: ''
        },
        nationality: 'US',
        disabled: false
      }
    },
    methods: {
      checkSiteCodeInsurance () {
        if (this.$store.state.configs['HIDE_ACCOUNT_SETUP_INSURANCE_ON_SITECODES'] === true) {
          return false
        }
        return true
      },
      updateDob (dobObject) {
        this.model.insured_date_of_birth = dobObject.composedDate
      },
      customizer (objValue, srcValue) {
        if (srcValue) {
          return srcValue
        } else {
          return objValue
        }
      },
      updateAddress (data) {
        this.model.addressComponents = data
        this.address_error = ''
      },
      updateAddress2 (data) {
        this.model.address2 = data
      },
      insuredUpdateAddress (data) {
        this.model.insured_address_components = data
        this.address_error = ''
      },
      insuredUpdateAddress2 (data) {
        this.model.insured_address2 = data
      },
      createFilter (queryString) {
        return (link) => {
          return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      getPolicyOrInsurance (policyNumber, policyBoolean) {
        if (policyBoolean) {
          policyNumber = policyNumber.slice(policyNumber.indexOf('-') + 2)
          return policyNumber
        } else {
          let insuranceName = policyNumber.slice(0, policyNumber.indexOf('-') - 1)
          return insuranceName
        }
      },
      async validate () {
        let info = await this.getPatientInfo()
        await this.$validator.validateAll()
        let nameSectionValidator = await this.$refs.nameSection.validate()
        let kitNumberBoolean = false
        if (this.$store.state.requirements.kit_number && this.type === 'Registration') {
          kitNumberBoolean = await this.$refs.scanningModule.validate()
          if (kitNumberBoolean) {
            this.model.kit_number = kitNumberBoolean
          }
          if (kitNumberBoolean === '') {
            kitNumberBoolean = true
          }
        } else {
          kitNumberBoolean = true
        }
        if (this.model.primary_insurance === 'Other' && this.model.primary_insurance_name_input !== '' && this.model.policy_number !== '' && !this.model.policy_number.includes('-')) {
          this.model.policy_number = this.model.primary_insurance_name_input + ' - ' + this.model.policy_number
        }
        if (this.$validator.errors.items.length) {
         // document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          this.$store.state.medDataValidator = false
        }
        this.address_error = ''
        if (this.checkRequirement('address')) {
          let addressValidation = this.$refs.AddressComponent.validate()
          if (!addressValidation) {
            this.address_error = 'All the required fields must be completed!'
            return false
          }
        }
        let geneticsSectionValidator = await this.$refs.GeneticsSection.validate()
        let personIdentifierSectionValidator = await this.$refs.personIdentifierSection.validate()
        // call driver license images validation
        if (this.allow_driver_license && this.type === 'Registration') {
          let driverLicenseArr = await this.$refs.driverLicense.validate()
          if (driverLicenseArr !== false && driverLicenseArr !== undefined && driverLicenseArr.length > 0) {
            this.model.driver_license_images = driverLicenseArr[0]
            this.model.driver_license_names = driverLicenseArr[1]
          } else {
            if (this.required_driver_license) {
              return false
            }
          }
        }
        let isAddressValid = false
        if (this.force_valid_address && !this.address_smartystreets_selected.invalid) {
          isAddressValid = true
        }
        if (!this.force_valid_address) {
          isAddressValid = true
        }
        if ((await this.$validator.validateAll() === true) && nameSectionValidator && geneticsSectionValidator && personIdentifierSectionValidator && isAddressValid && kitNumberBoolean) {
          // this.model = {...this.$store.state.user, ...this.model}
          // this.model = Object.assign(this.$store.state.user, this.model)
          _.mergeWith(this.model, this.$store.state.user, this.customizer)
          this.$store.state.currentData = this.model
          this.$store.state.currentData['info'] = info
          if (this.type === 'personalData') {
            if (this.$store.state.firstRegistration) {
              axios.post(process.env.SERVER_URI + '/account/add/sitecode', {'email': localStorage.getItem('email'), 'code': this.$store.state.sitecode}, {headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}})
                .then((response) => {
                  if (response.data) {
                    axios.post(process.env.SERVER_URI + '/account/update/user', this.$store.state.currentData, {headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}})
                      .then((response) => {
                        if (response.data === false) {
                          this.errorSave = 'There was an error submitting the data'
                        } else {
                          this.$store.state.firstRegistration = false
                          localStorage.setItem('firstName', this.model.firstName)
                          localStorage.setItem('lastName', this.model.lastName)
                          this.$store.state.clientLoggedKey += 1
                          this.errorSave = 'Data has been saved'
                          this.$store.state.medDataValidator = true
                        }
                      }).catch(error => {
                        console.log(error)
                        this.errorSave = 'There was an error submitting the data'
                      })
                  }
                })
            } else {
              axios.post(process.env.SERVER_URI + '/account/update/user', this.$store.state.currentData, {headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}})
              .then((response) => {
                if (response.data === false) {
                  this.errorSave = 'There was an error submitting the data'
                } else {
                  this.$store.state.firstRegistration = false
                  localStorage.setItem('firstName', this.model.firstName)
                  localStorage.setItem('lastName', this.model.lastName)
                  this.$store.state.clientLoggedKey += 1
                  this.errorSave = 'Data has been saved'
                  this.$store.state.medDataValidator = true
                  this.$store.state.firedesk40583_1 = JSON.parse(JSON.stringify(this.$store.state.currentData.addressComponents)) // stefan - 04/02/2025 - keep all lines that contain "firedesk40583"
                }
              }).catch(error => {
                console.log(error)
                this.errorSave = 'There was an error submitting the data'
              })
            }
          } else if (this.type === 'dependentUpdate') {
            if (this.checked) {
              this.model.insurance_same_as = 1
              this.$store.state.userData.insurance_same_as = 1
            } else {
              this.model.insurance_same_as = 0
              this.$store.state.userData.insurance_same_as = 0
            }
            this.model.id = this.$store.state.userData['id']
            axios.post(process.env.SERVER_URI + '/account/update/dependent', this.$store.state.currentData, {headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}})
              .then((response) => {
                if (response.data === false) {
                  this.errorSave = 'There was an error submitting the data'
                } else {
                  this.errorSave = 'Data has been saved'
                  let email = localStorage.getItem('email')
                  let one = process.env.SERVER_URI + '/account/get/dependents'
                  let two = process.env.SERVER_URI + '/account/check/user'
                  const requestOne = axios.post(one, {'email': email}, {
                    headers: {
                      'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                  })
                  const requestTwo = axios.post(two, {'email': email}, {
                    headers: {
                      'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                  })
                  axios.all([requestOne, requestTwo])
                    .then(axios.spread((...responses) => {
                      if (responses[0].data === false) {
                        this.$store.state.userData = []
                      } else if (responses[0].data) {
                        this.$store.state.dependentsData = responses[0].data
                      }
                      if (responses[1].data === false) {
                        this.$store.state.patientRegistrationData = {
                          firstName: '',
                          lastName: '',
                          passport: '',
                          dob: '',
                          dob_pretty: '',
                          address: '',
                          address2: '',
                          gender: '',
                          phone: '',
                          race: '',
                          ethnicity: '',
                          addressComponents: '',
                          primary_insurance: '',
                          primary_insurance_name_input: '',
                          policy_number: '',
                          group_number: '',
                          driver_license_number: '',
                          social_number: '',
                          insured_first_name: '',
                          insured_middle_name: '',
                          insured_last_name: '',
                          insured_gender: '',
                          insured_date_of_birth: '',
                          insured_address_components: '',
                          insured_address: '',
                          relationship: ''
                        }
                      } else if (responses[1].data) {
                        let addressInitial = {}
                        if (responses[1].data['addressComponents']) {
                          addressInitial = {
                            name: responses[1].data['addressComponents']['name'] || '',
                            original_name: responses[1].data['addressComponents']['original_name'] || '',
                            delivery_line_1: responses[1].data['addressComponents']['delivery_line_1'] || '',
                            city_name: responses[1].data['addressComponents']['city_name'] || '',
                            county: responses[1].data['addressComponents']['county'] || '',
                            state_abbreviation: responses[1].data['addressComponents']['state_abbreviation'] || '',
                            zipcode: responses[1].data['addressComponents']['zipcode'] || '',
                            plus4_code: responses[1].data['addressComponents']['plus4_code'] || '',
                            county_fips: responses[1].data['addressComponents']['county_fips'] || '',
                            country: responses[1].data['addressComponents']['country'] || ''
                          }
                        }
                        let insuredAddressInitial = {}
                        if (responses[1].data['insured_address_components']) {
                          insuredAddressInitial = {
                            name: responses[1].data['insured_address_components']['name'] || '',
                            original_name: responses[1].data['insured_address_components']['original_name'] || '',
                            delivery_line_1: responses[1].data['insured_address_components']['delivery_line_1'] || '',
                            city_name: responses[1].data['insured_address_components']['city_name'] || '',
                            county: responses[1].data['insured_address_components']['county'] || '',
                            state_abbreviation: responses[1].data['insured_address_components']['state_abbreviation'] || '',
                            zipcode: responses[1].data['insured_address_components']['zipcode'] || '',
                            plus4_code: responses[1].data['insured_address_components']['plus4_code'] || '',
                            county_fips: responses[1].data['insured_address_components']['county_fips'] || '',
                            country: responses[1].data['insured_address_components']['country'] || ''
                          }
                        }
                        let guardianAddressInitial = {}
                        if (responses[1].data['guardian_address_components']) {
                          guardianAddressInitial = {
                            name: responses[1].data['guardian_address_components']['name'] || '',
                            original_name: responses[1].data['guardian_address_components']['original_name'] || '',
                            delivery_line_1: responses[1].data['guardian_address_components']['delivery_line_1'] || '',
                            city_name: responses[1].data['guardian_address_components']['city_name'] || '',
                            county: responses[1].data['guardian_address_components']['county'] || '',
                            state_abbreviation: responses[1].data['guardian_address_components']['state_abbreviation'] || '',
                            zipcode: responses[1].data['guardian_address_components']['zipcode'] || '',
                            plus4_code: responses[1].data['guardian_address_components']['plus4_code'] || '',
                            county_fips: responses[1].data['guardian_address_components']['county_fips'] || '',
                            country: responses[1].data['guardian_address_components']['country'] || ''
                          }
                        }
                        this.$store.state.patientRegistrationData = {
                          firstName: responses[1].data['first_name'] || '',
                          lastName: responses[1].data['last_name'] || '',
                          middleName: responses[1].data['middle_name'] || '',
                          suffix: responses[1].data['suffix'] || '',
                          passport: responses[1].data['passport'] || '',
                          dob: responses[1].data['date_of_birth'] || '',
                          dob_pretty: responses[1].data['date_of_birth'] || '',
                          address: responses[1].data['address'] || '',
                          address2: responses[1].data['address2'] || '',
                          gender: responses[1].data['gender'] || '',
                          phone: responses[1].data['phone'] || '',
                          race: responses[1].data['race'] || '',
                          ethnicity: responses[1].data['ethnicity'] || '',
                          addressComponents: addressInitial,
                          guardianAddressComponents: guardianAddressInitial,
                          primary_insurance: responses[1].data['insurance_name'] || '',
                          policy_number: responses[1].data['policy_number'] || '',
                          group_number: responses[1].data['group_number'] || '',
                          driver_license_number: responses[1].data['driver_license_number'] || '',
                          social_number: responses[1].data['social_number'] || '',
                          insured_first_name: responses[1].data['insured_first_name'] || '',
                          insured_middle_name: responses[1].data['insured_middle_name'] || '',
                          insured_last_name: responses[1].data['insured_last_name'] || '',
                          insured_gender: responses[1].data['insured_gender'] || '',
                          insured_date_of_birth: responses[1].data['insured_date_of_birth'] || '',
                          insured_address_components: insuredAddressInitial,
                          insured_address: responses[1].data['insured_address'] || '',
                          insured_address2: responses[1].data['insured_address2'] || '',
                          relationship: responses[1].data['relationship'] || ''
                        }
                      }
                    }))
                }
              }).catch(error => {
                console.log(error)
                this.errorSave = 'There was an error submitting the data'
              })
          } else if (this.type === 'dependentRegistration') {
            if (this.checked) {
              this.model.insurance_same_as = 1
              this.$store.state.userData.insurance_same_as = 1
            } else {
              this.model.insurance_same_as = 0
              this.$store.state.userData.insurance_same_as = 0
            }
            axios.post(process.env.SERVER_URI + '/account/add/dependent', this.$store.state.currentData, {headers: {'Authorization': `Bearer ${localStorage.getItem('token')}`}})
              .then((response) => {
                if (response.data === false) {
                  this.errorSave = 'There was an error submitting the data'
                } else {
                  this.errorSave = 'Data has been saved'
                  let email = localStorage.getItem('email')
                  let one = process.env.SERVER_URI + '/account/get/dependents'
                  let two = process.env.SERVER_URI + '/account/check/user'
                  const requestOne = axios.post(one, {'email': email}, {
                    headers: {
                      'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                  })
                  const requestTwo = axios.post(two, {'email': email}, {
                    headers: {
                      'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                  })
                  axios.all([requestOne, requestTwo])
                    .then(axios.spread((...responses) => {
                      if (responses[0].data === false) {
                        this.$store.state.userData = []
                      } else if (responses[0].data) {
                        this.$store.state.dependentsData = responses[0].data
                      }
                      if (responses[1].data === false) {
                        this.$store.state.patientRegistrationData = {
                          firstName: '',
                          lastName: '',
                          passport: '',
                          dob: '',
                          dob_pretty: '',
                          address: '',
                          address2: '',
                          gender: '',
                          phone: '',
                          race: '',
                          ethnicity: '',
                          addressComponents: '',
                          primary_insurance: '',
                          policy_number: '',
                          group_number: '',
                          driver_license_number: '',
                          social_number: '',
                          insured_first_name: '',
                          insured_middle_name: '',
                          insured_last_name: '',
                          insured_gender: '',
                          insured_date_of_birth: '',
                          insured_address_components: '',
                          insured_address: '',
                          insured_address2: '',
                          relationship: ''
                        }
                      } else if (responses[1].data) {
                        let addressInitial = {}
                        if (responses[1].data['addressComponents']) {
                          addressInitial = {
                            name: responses[1].data['addressComponents']['name'] || '',
                            original_name: responses[1].data['addressComponents']['original_name'] || '',
                            delivery_line_1: responses[1].data['addressComponents']['delivery_line_1'] || '',
                            city_name: responses[1].data['addressComponents']['city_name'] || '',
                            county: responses[1].data['addressComponents']['county'] || '',
                            state_abbreviation: responses[1].data['addressComponents']['state_abbreviation'] || '',
                            zipcode: responses[1].data['addressComponents']['zipcode'] || '',
                            plus4_code: responses[1].data['addressComponents']['plus4_code'] || '',
                            county_fips: responses[1].data['addressComponents']['county_fips'] || '',
                            country: responses[1].data['addressComponents']['country'] || ''
                          }
                        }
                        let insuredAddressInitial = {}
                        if (responses[1].data['insured_address_components']) {
                          insuredAddressInitial = {
                            name: responses[1].data['insured_address_components']['name'] || '',
                            original_name: responses[1].data['insured_address_components']['original_name'] || '',
                            delivery_line_1: responses[1].data['insured_address_components']['delivery_line_1'] || '',
                            city_name: responses[1].data['insured_address_components']['city_name'] || '',
                            county: responses[1].data['insured_address_components']['county'] || '',
                            state_abbreviation: responses[1].data['insured_address_components']['state_abbreviation'] || '',
                            zipcode: responses[1].data['insured_address_components']['zipcode'] || '',
                            plus4_code: responses[1].data['insured_address_components']['plus4_code'] || '',
                            county_fips: responses[1].data['insured_address_components']['county_fips'] || '',
                            country: responses[1].data['insured_address_components']['country'] || ''
                          }
                        }
                        this.$store.state.patientRegistrationData = {
                          firstName: responses[1].data['first_name'] || '',
                          lastName: responses[1].data['last_name'] || '',
                          middleName: responses[1].data['middle_name'] || '',
                          suffix: responses[1].data['suffix'] || '',
                          passport: responses[1].data['passport'] || '',
                          dob: responses[1].data['date_of_birth'] || '',
                          dob_pretty: responses[1].data['date_of_birth'] || '',
                          address: responses[1].data['address'] || '',
                          address2: responses[1].data['address2'] || '',
                          gender: responses[1].data['gender'] || '',
                          phone: responses[1].data['phone'] || '',
                          race: responses[1].data['race'] || '',
                          ethnicity: responses[1].data['ethnicity'] || '',
                          addressComponents: addressInitial,
                          primary_insurance: responses[1].data['insurance_name'] || '',
                          policy_number: responses[1].data['policy_number'] || '',
                          group_number: responses[1].data['group_number'] || '',
                          driver_license_number: responses[1].data['driver_license_number'] || '',
                          social_number: responses[1].data['social_number'] || '',
                          insured_first_name: responses[1].data['insured_first_name'] || '',
                          insured_middle_name: responses[1].data['insured_middle_name'] || '',
                          insured_last_name: responses[1].data['insured_last_name'] || '',
                          insured_gender: responses[1].data['insured_gender'] || '',
                          insured_date_of_birth: responses[1].data['insured_date_of_birth'] || '',
                          insured_address_components: insuredAddressInitial,
                          insured_address: responses[1].data['insured_address'] || '',
                          insured_address2: responses[1].data['insured_address2'] || '',
                          relationship: responses[1].data['relationship'] || ''
                        }
                      }
                    }))
                  this.$store.state.currentData = ''
                }
              }).catch(error => {
                console.log(error)
                this.errorSave = 'There was an error submitting the data'
              })
          } else if (this.type === 'Registration') {
            this.$store.state.currentData.id = this.$store.state.userData.id || ''
            this.$store.state.medDataValidator = true
          }
        } else {
          this.$store.state.medDataValidator = false
         // document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
          return false
        }
      },
      switchInternational () {
        if (this.nationality === 'International') {
          this.$store.state.international = true
        } else {
          this.$store.state.international = false
        }
      }
    },
    async beforeMount () {
      this.personIdentifierObject = {
        model: this.$store.state.user
      }
      this.geneticsObject = {
        model: this.$store.state.user
      }
      this.nameObject = {
        model: this.$store.state.user
      }
      this.required_kit_number = this.checkRequirement('kit_number')
      this.modelValidations.driver_license_image.required = this.$store.state.configs['ALLOW_DRIVER_LICENSE'] === true && this.required_driver_license === true
      this.$store.state.international = false
      this.model.passport = this.$store.state.userData['passport'] || ''
      this.model.address = this.$store.state.userData['address'] || ''
      this.model.address2 = this.$store.state.userData['address2'] || ''
      this.model.phone = this.$store.state.userData['phone'] || ''
      this.model.addressComponents = this.$store.state.userData['addressComponents'] || this.addressInitial
      this.model.primary_insurance = this.$store.state.userData['primary_insurance'] || ''
      if (this.$store.state.userData['primary_insurance'] === 'Other') {
        this.model.primary_insurance_name_input = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', false)
        this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
      } else {
        this.model.primary_insurance_name_input = ''
        if (this.$store.state.userData['policy_number'].includes('-')) {
          this.model.policy_number = this.getPolicyOrInsurance(this.$store.state.userData['policy_number'] || '', true)
        } else {
          this.model.policy_number = this.$store.state.userData['policy_number'] || ''
        }
      }
      this.model.group_number = this.$store.state.userData['group_number'] || ''
      this.model.driver_license_number = this.$store.state.userData['driver_license_number'] || ''
      this.model.social_security_number = this.$store.state.userData['social_number'] || ''
      this.model.med_social_security_number = this.$store.state.userData['social_number'] || ''
      this.model.insured_first_name = this.$store.state.userData['insured_first_name'] || ''
      this.model.insured_middle_name = this.$store.state.userData['insured_middle_name'] || ''
      this.model.insured_last_name = this.$store.state.userData['insured_last_name'] || ''
      this.model.insured_gender = this.$store.state.userData['insured_gender'] || ''
      this.insured_dob = this.$store.state.userData['insured_date_of_birth'] || ''
      this.model.insured_address_components = this.$store.state.userData['insured_address_components'] || this.addressInitial
      this.model.insured_address = this.$store.state.userData['insured_address'] || ''
      this.model.insured_address2 = this.$store.state.userData['insured_address2'] || ''
      this.model.insured_address_components = this.$store.state.userData['insured_address_components'] || ''
      this.model.relationship = this.$store.state.userData['relationship'] || ''
      if (this.$store.state.sitecode !== false) {
        if (this.type === 'dependentRegistration') {
          this.model.primary_insurance = ''
          this.model.policy_number = ''
          this.model.group_number = ''
          this.model.insured_first_name = ''
          this.model.insured_middle_name = ''
          this.model.insured_last_name = ''
          this.model.insured_gender = ''
          this.insured_dob = ''
          this.model.insured_address_components = ''
          this.model.insured_address = ''
          this.model.insured_address_components = ''
          this.model.relationship = ''
        }
        this.updateAddress(this.model.addressComponents)
        this.$store.state.currentData = this.model
        if (this.type === 'dependentRegistration') {
          this.checked = true
        } else if (this.type === 'dependentUpdate') {
          if (this.$store.state.userData['insurance_same_as']) {
            this.checked = this.$store.state.userData['insurance_same_as'] === '1'
          } else {
            this.checked = true
          }
        }
        if (this.type === 'Registration') {
          this.$store.state.insuranceData.firstName = this.$store.state.nameComponentInsuranceData.firstName
          this.$store.state.insuranceData.middleName = this.$store.state.nameComponentInsuranceData.middleName
          this.$store.state.insuranceData.lastName = this.$store.state.nameComponentInsuranceData.lastName
          this.$store.state.insuranceData.gender = this.$store.state.geneticsComponentInsuranceData.gender
          this.$store.state.insuranceData.dob = this.$store.state.geneticsComponentInsuranceData.dob
          this.$store.state.insuranceData.dob_pretty = this.$store.state.geneticsComponentInsuranceData.dob_pretty
          this.$store.state.insuranceData.address = this.model.address
          this.$store.state.insuranceData.addressComponents = this.model.addressComponents
        }
        if (this.type === 'personalData') {
          this.insuredAddress += 1
          this.insuredUpdateAddress(this.model.insured_address_components)
        }
      }
     // this.model = _.mergeWith(this.$store.state.user, this.model, this.customizer)
    },
    computed: {
      hide_self_completed_fields () {
        return this.$store.state.configs.HIDE_SELF_COMPLETED_FIELDS
      },
      required_driver_license () {
        return this.$store.state.configs['REQUIRED_DRIVER_LICENSE']
      },
      ...mapFields(['email', 'address', 'address2', 'med_driver_license_number', 'phone', 'passport', 'primary_insurance', 'policy_number', 'primary_insurance_name_input', 'group_number', 'social_security_number', 'driver_licence_number', 'insured_first_name', 'insured_middle_name', 'insured_last_name', 'insured_date_of_birth', 'insured_gender', 'insured_address', 'insured_address2', 'relationship', 'med_social_security_number'])
    },
    watch: {
      'model.insured_date_of_birth': {
        handler: function (dobValue) {
        },
        deep: true
      },
      'model.social_security_number': {
        handler: function (after, before) {
          if (after !== '') {
            let ssnCleave = new Cleave('.ssn-cleave-format', {
              delimiters: ['-', '-'],
              numericOnly: true,
              uppercase: true,
              blocks: [3, 2, 4]
            })
            this.model.social_security_number = ssnCleave.getFormattedValue()
          }
        },
        deep: true
      },
      'model': {
        handler: function (after, before) {
          this.$store.state.currentData = this.model
        },
        deep: true
      },
      'checked': {
        handler: function (after, before) {
          if (this.checked === true && (this.type === 'dependentRegistration' || this.type === 'dependentUpdate')) {
            if (this.model.relationship === 'Self') {
              this.model.relationship = ''
            }
            this.relationshipList = this.relationshipListWithoutSelf
            this.model.primary_insurance = this.$store.state.patientRegistrationData['primary_insurance'] || ''
            this.model.policy_number = this.$store.state.patientRegistrationData['policy_number'] || ''
            this.model.group_number = this.$store.state.patientRegistrationData['group_number'] || ''
            this.model.insured_first_name = this.$store.state.patientRegistrationData['insured_first_name'] || ''
            this.model.insured_middle_name = this.$store.state.patientRegistrationData['insured_middle_name'] || ''
            this.model.insured_last_name = this.$store.state.patientRegistrationData['insured_last_name'] || ''
            this.model.insured_gender = this.$store.state.patientRegistrationData['insured_gender'] || ''
            this.insured_dob = this.$store.state.patientRegistrationData['insured_date_of_birth'] || ''
            this.model.insured_address_components = this.$store.state.patientRegistrationData['insured_address_components'] || this.addressInitial
            this.model.insured_address = this.$store.state.patientRegistrationData['insured_address'] || ''
            this.model.insured_address2 = this.$store.state.patientRegistrationData['insured_address2'] || ''
            this.insuredAddress += 1
            this.insuredUpdateAddress(this.model.insured_address_components)
          } else if (this.type === 'dependentUpdate' && this.checked === false) {
            this.relationshipList = this.relationshipListWithSelf
            if (this.model.relationship !== 'Self') {
              this.model.relationship = ''
            }
            this.model.relationship = this.$store.state.userData['relationship'] || ''
            this.model.primary_insurance = this.$store.state.userData['primary_insurance'] || ''
            this.model.policy_number = this.$store.state.userData['policy_number'] || ''
            this.model.group_number = this.$store.state.userData['group_number'] || ''
            this.model.insured_first_name = this.$store.state.userData['insured_first_name'] || ''
            this.model.insured_middle_name = this.$store.state.nameComponentInsuranceData['middleName'] || ''
            this.model.insured_last_name = this.$store.state.userData['insured_last_name'] || ''
            if (this.$store.state.requirements.gender) {
              this.model.insured_gender = this.$store.state.geneticsComponentInsuranceData['gender'] || ''
            }
            this.insured_dob = this.$store.state.geneticsComponentInsuranceData['dob'] || ''
            this.model.insured_address_components = this.$store.state.userData['insured_address_components'] || this.addressInitial
            this.model.insured_address = this.$store.state.userData['insured_address'] || ''
            this.model.insured_address2 = this.$store.state.userData['insured_address2'] || ''
            this.insuredAddress += 1
            this.insuredUpdateAddress(this.model.insured_address_components)
          } else if (this.checked === false && this.type === 'dependentRegistration') {
            this.relationshipList = this.relationshipListWithSelf
            if (this.model.relationship !== 'Self') {
              this.model.relationship = ''
            }
            this.model.primary_insurance = ''
            this.model.policy_number = ''
            this.model.group_number = ''
            this.model.insured_first_name = ''
            this.model.insured_middle_name = ''
            this.model.insured_last_name = ''
            this.model.insured_gender = ''
            this.insured_dob = ''
            this.model.insured_address_components = this.addressInitial
            this.model.insured_address = ''
          }
        }
      },
      'model.relationship': {
        handler: function (before, after) {
          this.$store.state.relationship = this.model.relationship
          if (this.model.relationship === 'Self') {
            if (Object.keys(this.model.addressComponents).length > 0) {
              this.model.insured_address_components = this.model.addressComponents
            }
            if (this.$store.state.requirements.gender) {
              this.model.insured_gender = this.nameObject.model.gender
            }
            this.model.insured_address2 = this.model.address2
            this.model.insured_first_name = this.nameObject.model.firstName
            this.model.insured_middle_name = this.nameObject.model.middleName
            this.model.insured_last_name = this.nameObject.model.lastName
            this.insured_dob = this.nameObject.model.dob
            if (this.model.address) {
              this.model.insured_address = this.model.address
            }
            this.insuredAddress += 1
            this.insuredUpdateAddress(this.model.insured_address_components)
          }
        }
      },
      'model.address2': {
        handler: function (val) {
          if (this.model.relationship === 'Self') {
            this.$store.state.dataForInsurance.address2 = val
            this.model.insured_address2 = val
          }
        }
      },
      'nameObject.model.firstName': {
        handler: function (val) {
          if (this.model.relationship === 'Self') {
            this.model.insured_first_name = val
          }
        }
      },
      'nameObject.model.lastName': {
        handler: function (val) {
          if (this.model.relationship === 'Self') {
            this.model.insured_last_name = val
          }
        }
      },
      'nameObject.model.middleName': {
        handler: function (val) {
          if (this.model.relationship === 'Self') {
            this.model.insured_middle_name = val
          }
        }
      },
      'nameObject.model.dob': {
        handler: function (val) {
          if (this.model.relationship === 'Self') {
            this.insured_dob = val
          }
        }
      },
      'nameObject.model.gender': {
        handler: function (val) {
          if (this.model.relationship === 'Self' && this.$store.state.requirements.gender) {
            this.model.insured_gender = val
          }
        }
      },
      'model.addressComponents': {
        handler: function (before, after) {
          if (this.model.relationship === 'Self') {
            this.model.insured_address_components = this.model.addressComponents
            this.insuredUpdateAddress(this.model.insured_address_components)
            this.model.insured_address = this.model.address
            this.insuredAddress += 1
          }
          if (this.type === 'Registration') {
            this.$store.state.insuranceData.addressComponents = this.model.addressComponents
            this.$store.state.insuranceData.address = this.model.address
            this.$store.state.user.addressComponents = this.model.addressComponents
            this.$store.state.user.address = this.model.address
          }
        },
        deep: true
      },
      '$store.state.nameComponentInsuranceData': {
        handler: function (before, after) {
          if (this.checked === true && (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') === false || this.checked === false && (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') && this.model.relationship === 'Self') {
            this.model.insured_first_name = this.$store.state.nameComponentInsuranceData.firstName
            this.model.insured_middle_name = this.$store.state.nameComponentInsuranceData.middleName
            this.model.insured_last_name = this.$store.state.nameComponentInsuranceData.lastName
          }
        }
      },
      '$store.state.geneticsComponentInsuranceData': {
        handler: function (before, after) {
          if (this.checked === true && (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') === false || this.checked === false && (this.type === 'dependentRegistration' || this.type === 'dependentUpdate') && this.model.relationship === 'Self') {
            if (this.$store.state.geneticsComponentInsuranceData.gender) {
              this.model.insured_gender = this.$store.state.geneticsComponentInsuranceData.gender
            }
            this.insured_dob = this.$store.state.geneticsComponentInsuranceData.dob
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../../../assets/sass/paper/_variables.scss';

>>> .el-select--large{
      width: 100%;
    }

>>> .el-autocomplete{
      width: 100%;
    }
  .disclaimer {
    font-size: 13px;
    color: green;
  }

  h5{
    margin-bottom: 25px;
  }

  .display-none {
    display: none;
  }

  .generic-answer {
    margin-top: 10px;
  }

  .float-right{
    float: right;
  }

  .p-0{
    padding: 0;
  }

  .w-100{
    width: 100% !important;
  }

  .pr-0{
    padding-right: 0;
  }

  .p-10{
    padding: 10px;
  }

  .pt-10{
    padding-top: 10px;
  }

  .scan-button{
    font-size: 17px;
    background: white;
    border: 1px solid red;
    border-radius: 5px;
  }

  .line-clamp {
    text-overflow: ellipsis;
    overflow: hidden;
    /* width: 500px; */
    height: 1.2em;
    white-space: nowrap;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  .d-inline-block{
    display: inline-block;
  }

  .mt-5{
    margin-top: 5px;
  }

  .mt-10{
    margin-top: 10px;
  }

  .button{
    width: 30% !important;
    float: right;
    background: $primary-color !important;
    color: white;
    border-radius: 5px;
  }
  .button-back{
    width: 100px !important;
    background: white !important;
    color: $secondary-color;
    border-radius: 5px;
  }

  .general-inactive-section:focus-within {
    border-left-color: $primary-color !important;
  }
  @media screen and (max-width: 991px) {
    .mt-5{
      margin-top: 0;
    }

    .mb-0{
      margin-bottom: 0;
    }

    .button {
      float:left;
      width: 100% !important;
    }
    .button-back {
      margin-bottom: 2px;
      float:left;
      width: 100% !important;
    }
    .pr-0{
      padding-left: 0;
    }
  }

  @media screen and (max-width: 365px) {
    >>> .el-radio-button--small .el-radio-button__inner {
      padding: 9px 7px;
    }
     .button {
      float:left;
      width: 100% !important;
    }
    .button-back {
      margin-bottom: 2px;
      float:left;
      width: 100% !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Account/Dashboard/MedDataRegistration.vue